// extracted by mini-css-extract-plugin
export default {"app":"App_app__h04I+","app_noScroll":"App_app_noScroll__iQSaW"};